import classNames from "classnames";
import styles from "./Spinner.module.scss";

type Props = {
    show: boolean;
    size?: number;
    className?: string;
};

export const Spinner = (
    {
        show,
        size = 24,
        className,
    }: Props
) => {
    if (!show) return null;

    return (
        <span
            className={classNames(styles.spinner, className)}
            style={{
                width: size,
                height: size,
            }}
        />
    );
};
